export default {"src":"/_next/static/media/window-awning.345448e8.svg","height":1000,"width":1000};